import Cookie from 'js-cookie';

const checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
        return response;
     } 
     //else if (response.status === 401) {
    //     Cookie.remove('userId', {
    //         domain: '.hetao101.com'
    //     });
    //     Cookie.remove('token', {
    //         domain: '.hetao101.com'
    //     });
    //     window.location.href = 'https://l.hetao101.com/login';

    //     return Promise.reject();
    // }

    const error = new Error(response.statusText);
    error.response = response;
    throw error;
};

const request = function (url, options){
    const userhead = {
        'Content-Type': 'application/json',
        'X-User-Id': Cookie.get('userId') || '0',
        'X-Platform': 'WEB',
        'Authorization': Cookie.get('token')
    };
    const headers = options && options.headers ? Object.assign({}, userhead, options.headers) : userhead;
    return fetch(url, {
        ...options,
        headers
    }).then(checkStatus);
};
export {
    request
};
